export default __webpack_public_path__ + "static/media/Map4-2.9d2afa86.png";